export type Either<RESULT, ERROR> = { success: true; value: RESULT } | { success: false; error: ERROR };

export const Ok = <T, E = never>(value: T): Either<T, E> => ({
  success: true,
  value,
});
export const Err = <E, T = never>(error: E): Either<T, E> => ({
  success: false,
  error,
});

export function mapErr<T, E, E2>(r: Either<T, E>, fn: (e: E) => E2): Either<T, E2> {
  return r.success ? r : Err(fn(r.error));
}

export async function fromPromise<T, E>(p: Promise<T>, onErr: (e: unknown) => E): Promise<Either<T, E>> {
  try {
    return Ok(await p);
  } catch (e) {
    return Err(onErr(e));
  }
}
